const serverConfig = {
  development: {
    url: 'https://parse.viacor.de/parse',
    appId: 'viacorApp',
  },
  staging: {
    url: 'https://staging.parse.viacor.de/parse',
    appId: 'viacorApp',
  },
  production: {
    url: 'https://parse.viacor.de/parse',
    appId: 'viacorApp',
  },
};

export default serverConfig;
